import { logToSentry } from 'utils/networkErrorUtils';
import { apis } from 'utils/lib/apis';

export const handleSaveStudentDifferentiationBulk = (body) => async () => {
  try {
    const data = await apis.post('classActivitiesRDS', '/gradebook/student-differentiation/bulk', {
      body,
    });
    return data;
  } catch (error) {
    if (error && error.message !== 'Network Error') {
      logToSentry({
        message: 'Saving student differentiation bulk',
        error,
        module: 'STUDENT_DIFFERENTIATION',
        operation: 'SAVE_BULK',
      });
    }
    throw error;
  }
};
